export const LOCALSTORAGE_PROMO_BANNER_PERFORMANCE =
  'pp_promo_banner_performance';
export const LOCALSTORAGE_PRINCPIAL_ITEM_KEY = 'current_principal';

/**
 * Gets principalId from local storage
 * @returns principalId | null (depending on whether a principal has been saved already)
 */
export const getPrincipalSlugFromLocalStorage = (): string | undefined => {
  try {
    const principalSlug = localStorage.getItem(LOCALSTORAGE_PRINCPIAL_ITEM_KEY);

    if (typeof principalSlug === 'string' && JSON.parse(principalSlug)) {
      return JSON.parse(principalSlug)?.currentPrincipal;
    }
  } catch (e) {
    console.warn(
      'LocalStorage is not available. The last selected principal cannot be read from LocalStorage.',
    );
  }
  return undefined;
};

/**
 * Stores principalSlug to local storage
 * @param principalSlug of current principal
 */
export const storePrincipalIdSlugLocalStorage = (
  principalSlug: string,
): void => {
  try {
    localStorage.setItem(
      LOCALSTORAGE_PRINCPIAL_ITEM_KEY,
      JSON.stringify({ currentPrincipal: principalSlug }),
    );
  } catch (e) {
    console.warn(
      'LocalStorage is not available. The last selected principal cannot be stored in the LocalStorage.',
    );
  }
};
